import React, { useContext, useEffect, useState } from 'react';
import { ContentChart } from '@meteor/frontend-core';
import { AppContext } from '../../../../contexts/AppContext';
import { cloneDeep } from 'lodash';
import ErrorBoundary from '../../../common/error-boundary';
import 'echarts-gl';

const Customize3DChart: React.FC<any> = (props) => {
  const { echartTheme, setGlobalEvent } = useContext(AppContext);
  const { property, tooltips = ['zoomIn'] } = props;
  const [options, setOptions] = useState<any>(null);

  const defaultChartOptions: any = {
    tooltip: {},
    legend: {
      data: [],
    },
    xAxis3D: {
      name: '',
      type: 'category',
      axisLabel: {
        color: '#FFF',
      },
    },
    yAxis3D: {
      name: '',
      type: 'category',
      axisLabel: {
        color: '#FFF',
      },
    },
    zAxis3D: {
      name: '',
      type: 'value',
      axisLabel: {
        color: '#FFF',
      },
    },
    grid3D: {
      top: '-8%',
      // boxWidth: 120,
      viewControl: {
        alpha: 20,
        beta: 10,
        autoRotate: true,
        autoRotateSpeed: 5,
      },
    },
    series: [
      {
        type: 'bar3D',
        shading: 'lambert',
        label: {
          fontSize: 16,
          borderWidth: 1,
        },
        itemStyle: {
          color: (params: any) => {
            switch (params.data.key) {
              case 0:
                return '#e6bfff';
              case 1:
                return '#bc5cf7';
              case 2:
                return '#7500c0';
            }
          },
        },
        emphasis: {
          label: {
            fontSize: 20,
            color: '#900',
          },
          itemStyle: {
            color: 'yellow',
          },
        },
      },
    ],
  };

  useEffect(() => {}, []);

  useEffect(() => {
    if (!property || !property.data) {
      return;
    }
    let op = defaultChartOptions;
    op.series[0].data = property.data;
    setOptions(cloneDeep({ ...op, echartTheme }));
  }, [property]);

  return (
    <div className="chart-3d">
      <ErrorBoundary>
        {options ? (
          <ContentChart
            title={{
              value: <></>,
              styles: { display: 'none' },
            }}
            opts={{ renderer: 'canvas' }}
            contentList={[]}
            chartOptions={options}
            showSeriesLabel={false}
            mouseWheelZoomLock={false}
            loading={false}
            height={'100%'}
            tooltips={tooltips}
            isBank={false}
            onChartEvent={setGlobalEvent}
          />
        ) : (
          <></>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default Customize3DChart;
